export default "__VITE_ASSET__BscTcHhO__"